import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import socket from "../tools/socke";

const DatosCadete = ({ cadete, onClick, PasoDatos }) => {

  const Usuario = ObtieneDatosCookies();

  const [formData, setFormData] = useState({
    nuevaCondicion: "",
    descripcion: "",
    resolucion: "",
    fechaResolucion: "",
  });

  // =====================================================
  // INPUTS
  // =====================================================

  const handleInputChange = (e) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // =====================================================
  // FOTO
  // =====================================================

  const muestroFoto = (valor) => {
    window.open(
      `https://wwwa.isepsantafe.net.ar/imagenes/${valor}`
    );
  };

  // =====================================================
  // GUARDAR
  // =====================================================

  const guardoOperacion = async ({
    promocionNueva = null,
  }) => {

    try {

      // ============================================
      // BODY
      // ============================================

      const actualizacionCondicion = {

        Cadete: {

          cadeteCondicion:
            formData.nuevaCondicion,

          cadeteEstado:
            formData.nuevaCondicion === "BAJA"
              ? "Suspendido"
              : "activo",

        },
CambioCondicion: {

  idUsuario: Usuario.id,

  cadeteDni:
    cadete.cadeteDni,

  condicionActual:
    formData.nuevaCondicion,

  condicionAnterior:
    cadete.cadeteCondicion,

  promocionId:
    cadete?.Promocions?.[0]?.id,

  promocionNueva:
    promocionNueva,

  resolucion:
    formData.resolucion,

  fechaResolucion:
    formData.fechaResolucion,

  descripcion:
    formData.descripcion,

},
 

      };

//       console.log("================================");
//       console.log("🔥 BODY A ENVIAR");
//       console.log(actualizacionCondicion);
//       console.log("================================");

      const token = btoa(
        `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
      );

      // ============================================
      // REQUEST
      // ============================================

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizoCadeteFinal/${cadete.cadeteDni}`,
        actualizacionCondicion,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

//       console.log("🔥 RESPONSE");
//       console.log(response.data);

      // ============================================
      // SOCKET
      // ============================================

      socket.emit(
        "reempadrone",
        cadete?.Promocions?.nombre || ""
      );

      // ============================================
      // ALERTA
      // ============================================

      Swal.fire(
        "Cambio Generado",
        "El cadete ha sido cambiado en su condición.",
        "success"
      );

      // ============================================
      // ACTUALIZAR
      // ============================================

      if (PasoDatos) {
        PasoDatos(response.data.cadeteActualizado);
      }

      if (onClick) {
        onClick();
      }

    } catch (error) {

//       console.log("❌ ERROR");
//       console.log(error);

      Swal.fire({
        title: "Error",
        text: "No se pudo actualizar el cadete",
        icon: "error",
      });

    }

  };

  // =====================================================
  // SAVE
  // =====================================================

  const handleSave = async () => {

    const {
      nuevaCondicion,
      descripcion,
      resolucion,
      fechaResolucion,
    } = formData;

    // ============================================
    // VALIDACION
    // ============================================

    if (
      !nuevaCondicion ||
      !descripcion ||
      !resolucion ||
      !fechaResolucion
    ) {

      Swal.fire({
        title: "Error",
        text: "Completa todos los campos",
        icon: "error",
      });

      return;
    }

    // ============================================
    // PROMOCION
    // ============================================

    let promocionSeleccionada = null;

    if (nuevaCondicion === "Regular") {

      const resultPromocion = await Swal.fire({

        title: "Seleccionar Promoción",

        html: `
          <select
            id="swal-promocion"
            class="swal2-select"
          >
            <option value="">
              Seleccionar...
            </option>

            <option value="2">
              2025-2026
            </option>

            <option value="4">
              2026-2027
            </option>

          </select>
        `,

        showCancelButton: true,

        confirmButtonText: "Continuar",

        cancelButtonText: "Cancelar",

        preConfirm: () => {

          const value =
            document.getElementById(
              "swal-promocion"
            ).value;

          if (!value) {

            Swal.showValidationMessage(
              "Debes seleccionar una promoción"
            );

            return false;
          }

          return value;
        },

      });

      if (!resultPromocion.isConfirmed) {
        return;
      }

      promocionSeleccionada =
        resultPromocion.value;

//       console.log(
//         "🔥 PROMOCION ELEGIDA:",
//         promocionSeleccionada
//       );
    }

    // ============================================
    // CONFIRMACION
    // ============================================

    const confirmacion = await Swal.fire({

      title: "¿Estás seguro?",

      text:
        "Vas a cambiar la condición del cadete.",

      icon: "warning",

      showCancelButton: true,

      confirmButtonText: "Sí, Guardar",

      cancelButtonText: "Cancelar",

    });

    if (!confirmacion.isConfirmed) {
      return;
    }

    // ============================================
    // GUARDAR
    // ============================================

    await guardoOperacion({
      promocionNueva:
        promocionSeleccionada,
    });

  };

  // =====================================================
  // SOCKETS
  // =====================================================

  useEffect(() => {

    socket.on("listaPresentes", () => {});

    return () => {
      socket.off("listaPresentes");
    };

  }, []);

  // =====================================================
  // RENDER
  // =====================================================

  return (
    <>
      <div
        style={{
          minWidth: "320px",
          maxWidth: "640px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          padding: "15px",
          backgroundColor: "#f9f9f9",
          fontSize: "12px",
          margin: "0 auto",
          overflowY: "auto",
        }}
      >

        {/* FOTO */}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "15px",
          }}
        >

          <img
            src={`https://wwwa.isepsantafe.net.ar/imagenes/${cadete.fotoCadete}`}
            alt="Foto Cadete"
            className="rounded-circle border"
            style={{
              height: "75px",
              width: "75px",
              cursor: "pointer",
            }}
            onClick={() =>
              muestroFoto(cadete.fotoCadete)
            }
          />

        </div>

        {/* TITULO */}

        <h2
          style={{
            fontSize: "18px",
            textAlign: "center",
            marginBottom: "15px",
            fontWeight: "bold",
            color: "#333",
          }}
        >

          CAMBIAR CONDICIÓN DE
          {" "}
          {cadete.cadeteNombre}
          {" "}
          {cadete.cadeteApellido}

        </h2>

        {/* FORM */}

        <form
          style={{ textAlign: "center" }}
          onSubmit={(e) => e.preventDefault()}
        >

          {/* CONDICION */}

          <div
            className="input-group-text"
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >

            <div style={{ width: "180px" }}>

              <label>
                Condición Actual
              </label>

              <input
                type="text"
                value={
                  cadete.cadeteCondicion || ""
                }
                disabled
                className="form-control"
              />

            </div>

            <div>

              <label>
                Cambiar condición a:
              </label>

              <select
                name="nuevaCondicion"
                value={formData.nuevaCondicion}
                onChange={handleInputChange}
                className="form-select"
              >

                <option value="">
                  Seleccionar...
                </option>

                {[
                  "Regular",
                  "LTB",
                  "BAJA",
                  "LiEs",
                  "Propedeutico",
                ]
                  .filter(
                    (cond) =>
                      cond !==
                      cadete.cadeteCondicion
                  )
                  .map((cond) => (

                    <option
                      key={cond}
                      value={cond}
                    >
                      {cond}
                    </option>

                  ))}

              </select>

            </div>

          </div>

          {/* DESCRIPCION */}

          <div
            className="input-group-text"
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >

            <div>

              <label>
                Motivo o Descripción
              </label>

              <textarea
                style={{
                  width: "400px",
                  height: "140px",
                }}
                name="descripcion"
                value={formData.descripcion}
                onChange={handleInputChange}
                className="form-control"
              />

            </div>

          </div>

          {/* RESOLUCION */}

          <div
            className="input-group-text"
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >

            <div>

              <label>
                Resolución
              </label>

              <input
                type="text"
                name="resolucion"
                value={formData.resolucion}
                onChange={handleInputChange}
                className="form-control"
              />

            </div>

            <div>

              <label>
                Fecha Resolución
              </label>

              <input
                type="date"
                name="fechaResolucion"
                value={formData.fechaResolucion}
                onChange={handleInputChange}
                className="form-control"
              />

            </div>

          </div>

          {/* BOTONES */}

          <div>

            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={handleSave}
            >
              CAMBIAR CONDICIÓN
            </button>

            <button
              type="button"
              className="btn btn-danger"
              onClick={() => onClick()}
            >
              CANCELAR
            </button>

          </div>

        </form>

      </div>
    </>
  );
};

export default DatosCadete;